import { render, staticRenderFns } from "./PodcastPage.vue?vue&type=template&id=5ed45a09&"
import script from "./PodcastPage.vue?vue&type=script&lang=js&"
export * from "./PodcastPage.vue?vue&type=script&lang=js&"
import style0 from "./PodcastPage.vue?vue&type=style&index=0&id=5ed45a09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports